import {
  ComponentSingleStyleConfig,
  Text,
  useStyleConfig,
} from "@chakra-ui/react";
import React from "react";
import { ComponentStyleProps } from "../../../../../lib/styles/props/component-style-props";

export type CMFormCommentHeaderUserNameProps = {
  value?: string;
} & ComponentStyleProps;

export const CMFormCommentHeaderUserName = ({
  value,

  sx,
  ...rest
}: CMFormCommentHeaderUserNameProps) => {
  const styles = useStyleConfig("CMFormCommentHeaderUserNameStyles");

  return (
    <Text sx={{ ...styles, ...sx }} {...rest}>
      {value}
    </Text>
  );
};

export const CMFormCommentHeaderUserNameStyles: ComponentSingleStyleConfig = {
  baseStyle: {
    fontSize: "sm",
    fontWeight: "bold",
    color: "gray.900",
  },
};
